export const mediumRisk = "Risco Médio - Alerta"; 
export const highRisk = "Risco elevado"; 